import BuyingStationService from '@/_services/BuyingStationService.js';

export default {
  namespaced: true,
  state: {
    list: [],
    count: 0,
    fetchedAt: 0,
    requestPromise: null,
    loading: false,
  },
  getters: {
    farmersList: (state) => state.list,
    farmersCount: (state) => state.count,
    farmersLoading: (state) => state.loading,
  },
  mutations: {
    SET_FARMERS(state, payload) {
      state.list = Array.isArray(payload.list) ? payload.list : [];
      state.count = payload.count || (Array.isArray(payload.list) ? payload.list.length : 0);
    },
    SET_FETCHED_AT(state, ts) {
      state.fetchedAt = ts;
    },
    SET_REQUEST_PROMISE(state, promise) {
      state.requestPromise = promise;
    },
    SET_LOADING(state, val) {
      state.loading = !!val;
    },
  },
  actions: {
    async fetchFarmers({ commit }, { page = 1, limit = 1000 } = {}) {
      commit('SET_LOADING', true);
      try {
        const res = await BuyingStationService.getFarmers({ page, limit });
        const list = res?.data?.farmers || [];
        const count = res?.data?.count || list.length || 0;
        commit('SET_FARMERS', { list, count });
        commit('SET_FETCHED_AT', Date.now());
        return list;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async fetchFarmersCached(
      { state, commit },
      { page = 1, limit = 1000, ttlMs = 5 * 60 * 1000 } = {}
    ) {
      const now = Date.now();
      const hasData = state.list && state.list.length > 0;
      const fresh = hasData && state.fetchedAt && (now - state.fetchedAt) < ttlMs;
      if (fresh) return Promise.resolve(state.list);
      if (state.requestPromise) return state.requestPromise;

      const p = (async () => {
        commit('SET_LOADING', true);
        try {
          const res = await BuyingStationService.getFarmers({ page, limit });
          const list = res?.data?.farmers || [];
          const count = res?.data?.count || list.length || 0;
          commit('SET_FARMERS', { list, count });
          commit('SET_FETCHED_AT', Date.now());
          return list;
        } finally {
          commit('SET_LOADING', false);
          commit('SET_REQUEST_PROMISE', null);
        }
      })();

      commit('SET_REQUEST_PROMISE', p);
      return p;
    },
  },
};